define.alias("shared/components/shared/referral-promo-banner", "media/components/shared/referral-promo-banner");